import { loan_quote } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function cancelLoanQuote({ url: { service }, token }: IAPI) {
  return async function cancelLoanQuote(
    id: string,
    input: loan_quote.CancelQuoteInput
  ) {
    const url = new URL(`/loan-quote/${id}/cancel`, service);
    const response = await fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(input),
    });
    if (!response.ok) {
      throw new Error(`Network response was not OK: ${response.status}`);
    }
    return (await response.json()) as loan_quote.LoanQuote;
  };
}
